<!-- <div fxLayout="column" fxLayoutAlign="start start"> -->
<app-create-ticket-component
  (syncFinished)="onSyncFinished($event)"
  [props]="childProps"
></app-create-ticket-component>
<!-- </div> -->
